import { render, staticRenderFns } from "./homeDetail.vue?vue&type=template&id=5f2dcecd&scoped=true&"
import script from "./homeDetail.vue?vue&type=script&lang=js&"
export * from "./homeDetail.vue?vue&type=script&lang=js&"
import style0 from "./homeDetail.vue?vue&type=style&index=0&id=5f2dcecd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f2dcecd",
  null
  
)

export default component.exports